import RestResource from "@/api/rest/rest-resource";
import {athubAxios} from "@/util";
import {ORGANIZATION_SERVER} from "@/api";

const userPerson = new RestResource({server: ORGANIZATION_SERVER, resource: 'userPerson'});

userPerson.batchAdd = (userPerson) => {
    let url = `${ORGANIZATION_SERVER}/userPerson/batch`;
    return new Promise((resolve, reject) => {
        athubAxios.post(url, [userPerson]).then(responseBody => {
            if (responseBody.status == 200) {
                resolve(responseBody);
            }
        }).catch(error => {
            reject(error);
        });
    });
}

userPerson.batchDelete = (userPersons) => {
    let userId = userPersons[0].userId;
    let personIds = userPersons.map(e => e.personId);
    let url = `${ORGANIZATION_SERVER}/userPerson/unbind/userid/${userId}`;
    return new Promise((resolve, reject) => {
        athubAxios.post(url, personIds).then(responseBody => {
            if (responseBody.status == 200) {
                resolve(responseBody);
            }
        }).catch(error => {
            reject(error);
        });
    });
}

userPerson.findDetailsByUserIds = (userIds) => {
    let url = `${ORGANIZATION_SERVER}/userPerson/person`;
    return new Promise((resolve, reject) => {
        athubAxios.post(url, userIds).then(responseBody => {
            if (String(responseBody.status) === '200') {
                resolve(responseBody);
            } else {
                reject(responseBody.message);
            }
        }).catch(error => {
            reject(error);
        });
    });
}

export default userPerson;